import { Backdrop } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    color: "#fff",
    zIndex: theme.zIndex.drawer + 1,
}));
